<template>
  <div class="b-modal">
    <div id="stl_cont" class="stl-preview"></div>
    <div class="c-modal-footer">
      <div class="checkbox-group" v-if="upper">
        <input
          type="checkbox"
          class="checkbox-input"
          id="upper"
          v-model="showUpper"
          @change="showJaw"
        />
        <label for="upper" class="checkbox-label">
          {{ $t("upperJawOriginal") }}
        </label>
      </div>

      <div class="checkbox-group" v-if="lower">
        <input
          type="checkbox"
          class="checkbox-input"
          id="lower"
          v-model="showLower"
          @change="showJaw"
        />
        <label for="lower" class="checkbox-label">
          {{ $t("lowerJawOriginal") }}
        </label>
      </div>

      <div class="checkbox-group" v-if="upperResult">
        <input
          type="checkbox"
          class="checkbox-input"
          id="upperResult"
          v-model="showUpperResult"
          @change="showJaw"
        />
        <label for="upperResult" class="checkbox-label">
          {{ $t("upperJawResult") }}
        </label>
      </div>

      <div class="checkbox-group" v-if="lowerResult">
        <input
          type="checkbox"
          class="checkbox-input"
          id="lowerResult"
          v-model="showLowerResult"
          @change="showJaw"
        />
        <label for="lowerResult" class="checkbox-label">
          {{ $t("lowerJawResult") }}
        </label>
      </div>
    </div>
  </div>
</template>
<script>
import ElementIcon from "@/components/elements/Icon.vue";
import { BLink, BRow, BCol, BImg, BPagination } from "bootstrap-vue";
import { StlViewer } from "@/libs/3dviewer/stl_viewer.min.js";
import NProgress from "nprogress";
import FileService from "@/services/file.service";

export default {
  components: {
    ElementIcon,
    BRow,
    BCol,
    BLink,
    BImg,
    BPagination,
  },
  props: {
    upper: {
      type: String,
      default: null,
    },
    lower: {
      type: String,
      default: null,
    },
    upperResult: {
      type: String,
      default: null,
    },
    lowerResult: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      showUpper: true,
      showLower: true,
      showUpperResult: true,
      showLowerResult: true,
    };
  },
  methods: {
    showJaw() {
      this.stl_viewer.set_opacity(1, this.showUpper ? 1 : 0); // upper original
      this.stl_viewer.set_opacity(2, this.showLower ? 1 : 0); // lower original
      this.stl_viewer.set_opacity(3, this.showUpperResult ? 1 : 0); // upper result
      this.stl_viewer.set_opacity(4, this.showLowerResult ? 1 : 0); // lower result
    },

    async addModel(id, fileId, color) {
      const response = await FileService.getFileById(fileId);
      const url = URL.createObjectURL(response.data);
      this.stl_viewer.add_model({ id, temp_filename: "mesh1.stl", filename: url, color });
    },

    uploadDone: function () {
      NProgress.done();
      this.loadingDone = true;
    },
    uploadProgress: function (load_status) {
      this.loadingDone = false;
      var sumLoading = 0;
      var allToLoad = 0;
      for (var i = 0; i < load_status.length; i++) {
        if (
          typeof load_status[i] === "undefined" ||
          typeof load_status[i]["total"] === "undefined"
        ) {
          continue;
        }
        allToLoad += load_status[i]["total"];
        sumLoading += load_status[i]["loaded"];
      }

      var percentage = sumLoading / allToLoad;
      console.log(percentage);
      if (percentage > 0.8) {
        NProgress.set(0.6);
        // setTimeout(this.keepProgressbarBusy.bind(this), 1100);
      } else {
        NProgress.set(percentage);
      }
    },
  },
  async mounted() {
    this.$store.commit("showLoader", true);
    try {
      this.stl_viewer = new StlViewer(document.getElementById("stl_cont"), {
        all_loaded_callback: () => {
          requestAnimationFrame(() => {
            this.$store.commit("showLoader", false);
            this.uploadDone();
          });
        },
        loading_progress_callback: this.uploadProgress.bind(this),
        center_models: false,
        auto_rotate: true,
        controls: 1,
        allow_drag_and_drop: false,
      });

      if (this.upper != null) {
        await this.addModel(1, this.upper, "#7A5E42");
      } else {
        this.showUpper = false;
      }

      if (this.lower != null) {
        await this.addModel(2, this.lower, "#7A5E42");
      } else {
        this.showLower = false;
      }

      if (this.upperResult != null) {
        await this.addModel(3, this.upperResult, "#4E6B4E");
      } else {
        this.showUpperResult = false;
      }

      if (this.lowerResult != null) {
        await this.addModel(4, this.lowerResult, "#4E6B4E");
      } else {
        this.showLowerResult = false;
      }
    } catch (e) {
      this.$store.commit("showLoader", false);
    }
  },
};
</script>
